<script setup lang="ts">
import { MenuItem } from '@headlessui/vue'
import type { RouteLocationRaw } from 'vue-router'

defineProps<{
  to?: RouteLocationRaw
}>()

const getMenuItemClass = (active: boolean) => {
  const cls = [
    'hover:bg-gray-50 active:bg-gray-100',
    'hover:text-gray-800',
    'flex items-center gap-2',
    'w-full',
    'px-3 py-1.5',
    'text-left',
    'text-sm',
    'rounded-md',
  ]

  if (active)
    cls.push('bg-gray-100 text-gray-800')
  else
    cls.push('bg-white text-gray-700 ')

  return cls
}
</script>

<template>
  <MenuItem
    v-slot="{ active }"
  >
    <NuxtLink
      v-if="to"
      :to="to"
      :class="getMenuItemClass(active)"
    >
      <slot />
    </NuxtLink>
    <button
      v-else
      :class="getMenuItemClass(active)"
    >
      <slot />
    </button>
  </MenuItem>
</template>
